import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          "General": "General",
          "Dashboards": "Dashboards",
          "Dashboard": "Dashboard",
          "Default": "Default",
          "Payment Type": "Payment Type",
          "Ecommerce": "Ecommerce",
          "Users": "Users",
          "Widgets": "Widgets",
          "Firms": "Firms",
          "Proxies": "Election Portal",
          "Digital Ids": "Digital IDs",
          "Chart": "Chart",
          "Update AGM Payment Proof": "Update AGM Payment Proof",
         " Applications": "Applications",
          "Ready to use Apps": "Ready to use Apps",
          "Firm Updates": "Firm Updates",
          "Upload Payment Proof": "Upload Payment Proof",
          "New Membership": "New Membership",
          "Renew Membership": "Renew Membership",
          "Provincial Fees": "Provincial Fees",
          "Annual General Meeting Fees(AGM)": "Annual General Meeting Fees(AGM)",
          "Price": "Price",
          "Membership Payment Proof": "Membership Payment Proof",
          "New update to the firm": "New update to the firm",
          "Welcome, your dashboard is ready!":
            "Welcome, your dashboard is ready!",
          "Firm List": "Firm List",
          "ID": "ID",
          "Name": "Name",
          "Pan Number": "Pan Number",
          "Type of Organization": "Type of Organization",
          "Status": "Status",
          "Actions": "Actions",
          "Add New": "Add New",
          "Proxy List": "Representatives List",
          "Filter by Name": "Filter by Name",
          "Proxy UID": "Proxy UID",
          "Name of Firm": "Name of Firm",
          "Update Payment Proof": "Update Payment Proof",
          "Digital Id List": "Digital Id List",
          "Digital UID": "Digital UID",
          "User List": "User List",
          "Year": "Year",
          "Phone Number": "Phone Number",
          "Bulk Upload": "Bulk Upload",
          "Filter by Province": "Filter by Province",
          "Filter by District": "Filter by District",
          "Filter by Status": "Filter by Status",
          "Update User Role": "Update User Role",
          "Close": "Close",
          "Update": "Update",
          "Add Firm": "Add Firm",
          "Type of Firm": "Type of Firm",
          "Contact Person": "Contact Person",
          "Position": "Position",
          "Update Contact Person Passport Photo":
          "Upload a profile picture",
          "Province": "Province",
          "District": "District",
          "City": "City",
          "Address": "Address",
          "ncell1": "1. Ncell users dial *9966# and NTC users dial *922#",
          "ncell2": "2. A message with registered name for the number will be displayed",
          "ncell3": "3. Take a sereenshot and upload it here.",
          "Firm Latitude": "Firm Latitude",
          "Firm Longitude": "Firm Longitude",
          "Upload Stamp of firm": "Upload picture of stamp",
          "Upload Suporting Document": "Upload NADA Document",
          "Upload Another Suporting Document":
          "Upload screenshot",
          "Set Current Location": "Set Current Location",
          "Drop A File": "Drop A File",
          "Name is required": "Name is required",
          "Pan Number is required": "Pan Number is required",
          "Position is required": "Position is required",
          "Address is required": "Address is required",
          "Passport Size Photo is required": "Passport Size Photo is required",
          "Stamp Image is required": "Stamp Image is required",
          "Contact Person is required": "Contact Person is required",
          "Phone Number is required": "Incorrect Number",
          "same as logged user?": "same as logged user?",
          "Edit Firm": "Edit Firm",
          "View current Photo": "View current Photo",
          "Update Stamp of firm": "Update Stamp of firm",
          "View current Stamp": "View current Stamp",
          "Update Supporting Document": "Upload NADA Document",
          "View current supporting document": "View current supporting document",
          "Update Another Supporting Document":"Upload screenshot",
          "View current supporting document 2": "View current supporting document 2",
          "Firm Notes": "Firm Notes",
          "Firm Status": "Firm Status",
          "Update Firm": "Update Firm",
          "Current Passport Size Photo": "Current Passport Size Photo",
          "Password": "Password",
          "Update Profile": "Update Profile",
          "User Edit": "User Edit",
          "Bulk Upload Firms": "Bulk Upload Firms",
          "Upload CSV File": "Upload CSV File",
          "Upload": "Upload",
          "Sign In To NADA Admin Portal": "Sign In To NADA Admin Portal",
          "Sign In To NADA": "Sign In To NADA",
          "Welcome back! Log in to your account.": "Welcome back! Log in to your account.",
          "Forgot Password": "Forgot Password",
          "Sign In": "Sign In",
          "Don't have account ?": "Don't have account ?",
          "Create Account": "Create Account",
          "Create your account": "Create your account",
          "Already have an account?": "Already have an account?",
          "Already have an password?": "Already have an password?",
          "Continue": "Continue",
          "OTP Code": "OTP Code",
          "Enter 4-digit code": "Enter 4-digit code",
          "Enter your phone number to start": "Enter your phone number to start",
          "Select Organization": "Select Organization",
          "Add Proxy": "Add Proxy",
          "Edit Proxy": "Edit Proxy",
          "Organization": "Organization",
          "Your Position at the organization": "Your Position at the organization",
          "Update Proxy": "Update Proxy",
          "Edit": "Edit",
          "View": "View",
          "Print": "Print",
          "Download": "Download",
          "Upload Your Passport Size Photo": "Upload Your Passport Size Photo",
          "Picture is required": "Picture is required"
        },
      },
      es: {
        translations: {
          "General": "General",
          "Dashboards": "ड्यासबोर्डहरू",
          "Dashboard": "ड्यासबोर्ड",
          "Default": "पूर्वनिर्धारित",
          "Ecommerce": "Comercio electrónico",
          "Users": "प्रयोगकर्ताहरू",
          "Firms": "फर्महरू",
          "Membership Payment Proof": "सदस्यता भुक्तानी प्रमाण",
          "Proxies": "निर्वाचन पोर्टल",
          "Update Payment Proof": "भुक्तानी प्रमाण अपडेट गर्नुहोस्",
          "Digital Ids": "डिजिटल आईडी",
          "Widgets": "Widgets",
          "Chart": "Gráfico",
          "Applications": "Aplicaciones",
          "Ready to use Apps": "Gereed om programme te gebruik",
          "Firm Updates": "फर्म अपडेटहरू",
          "New update to the firm": "फर्ममा नयाँ अपडेट",
          "Welcome, your dashboard is ready!":
            "स्वागत छ, तपाईंको ड्यासबोर्ड तयार छ!",
          "Firm List": "फर्म सूची",
          "ID": "आईडी",
          "Name": "नाम",
          "Pan Number": "प्यान नम्बर",
          "Type of Organization": "संगठनको प्रकार",
          "Status": "स्थिति",
         "Actions": "कार्यहरू",
         "ncell1": "१. एनसेल प्रयोगकर्ताहरूले *९९६६# डायल गर्नुहोस् र एनटीसी प्रयोगकर्ताहरूले *९२२# डायल गर्नुहोस्।",
         "ncell2": "२. नम्बरको लागि दर्ता गरिएको नाम सहितको सन्देश प्रदर्शित हुनेछ।",
         "ncell3": "३. सेरिनसट लिनुहोस् र यहाँ अपलोड गर्नुहोस्।",
          "Add New": "नयाँ थप्नुहोस्",
          "Proxy List": "प्रतिनिधि सूची",
          "Filter by Name": "नाम द्वारा फिल्टर गर्नुहोस्",
          "Proxy UID": "प्रोक्सी UID",
          "Name of Firm": "फर्मको नाम",
          "Digital Id List": "डिजिटल आईडी सूची",
          "Digital UID": "डिजिटल UID",
          "User List": "प्रयोगकर्ता सूची",
          "Phone Number": "फोन नम्बर",
          "Year": "वर्ष",
          "Bulk Upload": "बल्क अपलोड",
          "Upload Payment Proof": "भुक्तानी प्रमाण अपलोड गर्नुहोस्",
          "New Membership": "नयाँ सदस्यता",
          "Renew Membership": "सदस्यता नवीकरण",
          "Provincial Fees": "प्रदेश शुल्क",
          "Annual General Meeting Fees(AGM)": "वार्षिक साधारण सभा शुल्क (AGM)",
          "Price": "मूल्य",
          "Filter by Province": "प्रान्त अनुसार फिल्टर गर्नुहोस्",
          "Filter by District": "जिल्ला अनुसार फिल्टर गर्नुहोस्",
          "Filter by Status": "स्थिति अनुसार फिल्टर गर्नुहोस्",
          "Update User Role": "प्रयोगकर्ता भूमिका अपडेट गर्नुहोस्",
          "Close": "बन्द गर्नुहोस्",
          "Update": "अपडेट गर्नुहोस्",
          "Add Firm": "फर्म थप्नुहोस्",
          "Type of Firm": "फर्मको प्रकार",
          "Contact Person": "सम्पर्क व्यक्ति",
          "Position": "पद",
          "Update Contact Person Passport Photo": "प्रोफाइल तस्वीर अपलोड गर्नुहोस्",
          "Province": "प्रदेश",
          "Update AGM Payment Proof": "वार्षिक साधारण सभा भुक्तानी प्रमाण अद्यावधिक गर्नुहोस्",
          "District": "जिल्ला",
          "City": "सहर",
          "Address": "ठेगाना",
          "Firm Latitude": "फर्मको अक्षांश",
          "Firm Longitude": "फर्मको देशान्तर",
          "Upload Stamp of firm": "टिकटको तस्वीर अपलोड गर्नुहोस्",
          "Upload Suporting Document": "NADA कागजात अपलोड गर्नुहोस्",
          "Upload Another Suporting Document": "स्क्रिनसट अपलोड गर्नुहोस्",
          "Set Current Location": "हालको स्थान सेट गर्नुहोस्",
          "Drop A File": "एउटा फाइल छोड्नुहोस्",
          "Name is required": "नाम आवश्यक छ",
          "Pan Number is required": "प्यान नम्बर आवश्यक छ",
          "Position is required": "पद आवश्यक छ",
          "Address is required": "ठेगाना आवश्यक छ",
          "Passport Size Photo is required": "पासपोर्ट साइज फोटो आवश्यक छ",
          "Stamp Image is required": "छापको छवि आवश्यक छ",
           "Contact Person is required": "सम्पर्क व्यक्ति आवश्यक छ",
          "Phone Number is required": "गलत नम्बर",
          "same as logged user?": "लग गरिएको प्रयोगकर्ता जस्तै?",
          "Edit Firm": "फर्म सम्पादन गर्नुहोस्",
          "View current Photo": "हालको फोटो हेर्नुहोस्",
          "Update Stamp of firm": "फर्मको स्टाम्प अद्यावधिक गर्नुहोस्",
          "View current Stamp": "हालको स्टाम्प हेर्नुहोस्",
          "Update Supporting Document": "NADA कागजात अपलोड गर्नुहोस्",
          "View current supporting document": "हालको सहायक कागजात हेर्नुहोस्",
          "Update Another Supporting Document": "स्क्रिनसट अपलोड गर्नुहोस्",
          "View current supporting document 2": "हालको सहायक कागजात २ हेर्नुहोस्",
          "Firm Notes": "फर्म टिप्पणीहरू",
          "Firm Status": "फर्म स्थिति",
          "Update Firm": "फर्म अद्यावधिक गर्नुहोस्",
          "Current Passport Size Photo": "हालको पासपोर्ट आकारको फोटो",
  "Password": "पासवर्ड",
  "Update Profile": "प्रोफाइल अद्यावधिक गर्नुहोस्",
  "User Edit": "प्रयोगकर्ता सम्पादन",
  "Bulk Upload Firms": "फर्महरू थोकमा अपलोड गर्नुहोस्",
  "Upload CSV File": "CSV फाइल अपलोड गर्नुहोस्",
  "Upload": "अपलोड गर्नुहोस्",
  "Payment Type": "भुक्तानी प्रकार",
  "Sign In To NADA Admin Portal": "NADA प्रशासक पोर्टलमा साइन इन गर्नुहोस्",
  "Sign In To NADA": "NADA पोर्टलमा साइन इन गर्नुहोस्",
  "Welcome back! Log in to your account.": "फेरि स्वागत छ! आफ्नो खातामा लग इन गर्नुहोस्।",
  "Forgot Password": "पासवर्ड बिर्सनुभयो",
  "Sign In": "साइन इन गर्नुहोस्",
  "Don't have account ?": "खाता छैन?",
  "Create Account": "खाता सिर्जना गर्नुहोस्",
  "Create your account": "आफ्नो खाता सिर्जना गर्नुहोस्",
  "Already have an account?": "पहिले नै खाता छ?",
  "Already have an password?": "पहिले नै पासवर्ड छ?",
  "Continue": "जारी राख्नुहोस्",
  "OTP Code": "OTP कोड",
  "Enter 4-digit code": "४-अंकको कोड प्रविष्ट गर्नुहोस्",
  "Enter your phone number to start": "सुरु गर्न आफ्नो फोन नम्बर प्रविष्ट गर्नुहोस्",
  "Select Organization": "संस्था चयन गर्नुहोस्",
  "Add Proxy": "प्रोक्सी थप्नुहोस्",
  "Edit Proxy": "प्रोक्सी सम्पादन गर्नुहोस्",
  "Organization": "संस्था",
  "Your Position at the organization": "संस्थामा तपाईंको पद",
  "Update Proxy": "प्रोक्सी अद्यावधिक गर्नुहोस्",
  "Edit": "सम्पादन गर्नुहोस्",
  "View": "हेर्नुहोस्",
  "Print": "प्रिन्ट गर्नुहोस्",
  "Download": "डाउनलोड गर्नुहोस्",
  "Upload Your Passport Size Photo": "आफ्नो पासपोर्ट आकारको फोटो अपलोड गर्नुहोस्",
  "Picture is required": "फोटो आवश्यक छ"

        },
      },
    },
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
